module.exports = __webpack_public_path__ + "static/img/pt.8df353f8.png";